import { FC } from 'react';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../../../common/basic/QcsModalBox';
import { SectionHeader } from '../../../common/SectionHeader';
import { QcsBox } from '../../../common/basic/QcsBox';
import { QcsLoadingButton } from '../../../common/basic/QcsLoadingButton';
import { invitationGetUpdateDto, useInvitation } from './invitationFunctions';
import { InvitationActivityDto } from '@api/models/invitation/InvitationActivityDto';
import { invitationService } from '@api/services/services';

interface Props {
  activity?: InvitationActivityDto;
  onClose: () => void;
}

export const ActivityDeleteModal: FC<Props> = ({ activity, onClose }) => {
  const { t, invitation, callWithLock, reloadInvitation, isSaving, setIsSaving } = useInvitation();

  const confirmDeleteActivity = async () => {
    setIsSaving(true);
    await callWithLock(async () => {
      const data2 = invitationGetUpdateDto(invitation);
      const data3 = {
        ...data2,
        activities: data2.activities.filter((x) => x.id !== activity?.activity?.id),
      };

      await invitationService.update(invitation.id!, data3);
      await reloadInvitation();

      onClose();
    });
    setIsSaving(false);
  };

  return (
    <QcsModal open={!!activity} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title={t('invitation.tabs.askDeleteActivity')} />
        <QcsBox sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <QcsLoadingButton loading={isSaving} variant="contained" onClick={confirmDeleteActivity}>
            {t('common.yes')}
          </QcsLoadingButton>
          <QcsLoadingButton loading={isSaving} variant="outlined" onClick={onClose}>
            {t('common.no')}
          </QcsLoadingButton>
        </QcsBox>
      </QcsModalBox>
    </QcsModal>
  );
};
